import Parse from '@/parse'

export default {
  initForm ({ state, commit }) {
    if (state.eventQuizset) {
      commit('setQuizset', state.eventQuizset.get('quizset'))
    } else {
      commit('setQuizset', null)
    }
  },

  async get ({ state, commit }) {
    const query = new Parse.Query('EventQuizset')
    const event = new Parse.Object('Event')
    event.id = state.eventId
    query.equalTo('event', event)
    query.include('quizset')
    try {
      let object = await query.first()
      commit('setEventQuizset', object)
      if (!object) {
        return
      }
      commit('setQuizset', object.get('quizset'))
    } catch (error) {
      console.log(error)
    }
  },

  async save ({ state, dispatch }) {
    let eventQuizsetId = null
    if (state.eventQuizset) {
      eventQuizsetId = state.eventQuizset.id
    }
    try {
      return await Parse.Cloud.run('saveEventQuizset', {
        eventQuizsetId: eventQuizsetId,
        eventId: state.eventId,
        quizsetId: state.quizset.id
      })
    } catch (error) {
      console.log(error)
      dispatch(
        'snackBar/addMessage',
        error,
        { root: true }
      )
    }
  },

  async availableQuizsets ({ state, commit }) {
    const quizsets = await Parse.Cloud.run('availableQuizsets', {
      eventId: state.eventId
    })
    commit('setQuizsets', quizsets)
  }
}
